import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  padding: 20px 100px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  ${props => props.theme.media.tabletLandscapeUp} {
    padding: 48px 160px;
  }

  ${props => props.theme.media.tabletPortraitDown} {
    padding: 24px 24px 24px;
    justify-content: space-between;
  }
`;

export const SubContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 24px;
  ${props => props.theme.media.tabletPortraitDown} {
    display: none;
  }
`;
